import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Tabs, Tab } from "@mui/material";
import {
  Button as Btn,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import { Spinner } from "../../components";
import { useCookies } from "react-cookie";
import DeleteModal from "../modal/DeleteModal";
import Client from "../../model/client";
import Estimate from "../../model/estimate";
import Bundle from "../../model/bundle";
import Product from "../../model/product";
import BundleItem from "../../model/bundleItem";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import MainLogo from "../../assets/main.png";
import DateConverter from "../../utils/DateConverter";
import ApiService from "../../service/ApiService";
import DatabaseEntities from "../../model/enum/DatabaseEntities";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "../../assets/admin/edit-icon.svg";
import ClientModal from "../client/ClientModal";
import PaymentMethod from "../../model/paymentMethod";
import Calendar from "react-calendar";
import StagedPayment from "../../model/stagedPayment";
import ToastMessages from "../../model/enum/ToastMessages";
import DB_Status from "../../model/enum/DBStatus";
import AlertService from "../../service/AlertService";
import PageResultResponse from "../../model/pageResultResponse";
import ImageCompressor from "../../utils/ImageCompressor";
import FirebaseService from "../../service/FirebaseService";
import Select, { StylesConfig } from "react-select";
import styled from "styled-components";
import Misc from "../../utils/Misc";
import useStyles from "./styles";
import "../styles/tableStyles.css";
import {
  DarkGrey,
  LightPrimaryColor,
  PrimaryColor,
  White,
} from "../../shared/styles/colors";

export const CalendarWrapper = styled.div`
  .react-calendar {
    width: 110%;
    background: white;
    border-radius: 5px;
  }
  .react-calendar__navigation__label,
  .react-calendar__navigation__arrow {
    background-color: white; /* Custom color */
    color: black; /* Button text color */
    border: none; /* Remove default border */
    padding: 5px 10px;
    border-radius: 20px;
    cursor: pointer;
  }

  .react-calendar__navigation__arrow:hover {
    background-color: #0056b3; /* Darker shade on hover */
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:after {
    color: white; /* Text color for active date */
    background: #1e2e55;
    border-radius: 20px; /* Optional: make the button rounded */
  }

  .react-calendar__tile--active:hover {
    background-color: #1e2e5580; /* Darker color on hover */
  }
`;

const style = {
  position: "absolute" as "absolute",
  top: "5%", // Start from a fixed top position
  left: "50%",
  transform: "translateX(-50%)", // Only horizontally center the modal
  width: "90% !important",
  maxWidth: "85rem",
  bgcolor: "#F9F9F9",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 2,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "85%",
  },
};

const styles: StylesConfig<any, true> = {
  container: (base) => ({
    ...base,
    width: "100% !important",
    borderColor: DarkGrey,
    borderRadius: "5px",
    marginLeft: "10px",
  }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? PrimaryColor : DarkGrey,
    boxShadow: state.isFocused ? LightPrimaryColor : base.boxShadow,
    "&:hover": {
      borderColor: PrimaryColor,
    },
    "&:selected": {
      borderColor: PrimaryColor,
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? LightPrimaryColor
      : state.isSelected
      ? PrimaryColor
      : base.backgroundColor,
    color: state.isFocused || state.isSelected ? White : base.color,
  }),
  menu: (base) => ({
    ...base,
  }),
};

type Task = {
  id: number;
  task: string;
  description: string;
  quantity: number;
  rate: number;
  amount: number;
  IsBundle: boolean;
  BundleItems: Array<BundleItem>;
};

const EstimateModal = ({ estimate, resetList }: any) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [cookies] = useCookies(["session"]);
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(0); // Active tab

  const edit = estimate != null;
  const code = edit ? estimate.code : null;
  const [client, setClient] = useState(edit ? estimate.Client : null);
  const [clients, setClients] = useState<Client[]>([]);
  const [dueDate, setDueDate] = useState(
    edit ? estimate.dueDate : new Date().setDate(new Date().getDate() + 30)
  ); // Default to 30 days from today
  const status = edit ? estimate.Status : { id: 2, name: "Pending" };
  const userId = edit ? estimate.User.id : cookies.session.userId;
  const [notes, setNotes] = useState(edit ? estimate.notes : null);
  const [approved, setApproved] = useState(edit ? estimate.approved : false);
  const [acceptedBy, setAcceptedBy] = useState(
    edit ? estimate.acceptedBy : null
  );
  const [acceptedAt, setAcceptedAt] = useState(
    edit ? estimate.acceptedAt : null
  );
  const [startsAt, setStartsAt] = useState(
    edit ? estimate.startsAt : new Date().setDate(new Date().getDate() + 1)
  ); // Default to tomorrow
  const [urgentPayment, setUrgentPayment] = useState(
    edit ? estimate.urgentPayment : false
  );
  const [deposit, setDeposit] = useState(edit ? true : false);
  const createdAt = edit ? new Date(estimate.createdAt) : null;
  const [total, setTotal] = useState(edit ? estimate.total : null);
  const [discount, setDiscount] = useState(edit ? estimate.discount : 0);
  const [discountType, setDiscountType] = useState("percentage");
  const [bundles, setBundles] = useState<Bundle[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [paymentMethodId, setPaymentMethodId] = useState(
    edit ? estimate.paymentMethod : null
  );
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [stagedAmount, setStagedAmount] = useState(0);
  const [size, setSize] = useState("Tomorrow");
  const [endSize, setEndSize] = useState("1 month");
  const [attachments, setAttachments] = useState<File[]>([]);
  const [estimateItems, setEstimateItems] = useState<Task[]>(
    edit
      ? estimate.items
      : [
          {
            id: 0,
            task: "",
            description: "",
            quantity: 0,
            rate: 0,
            amount: 0,
            BundleItems: [],
          },
        ]
  );

  // Fetch all the clients, bundles and products from the database
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [clientsData, bundlesData, productsData, paymentMethodsData] =
          await Promise.all([
            ApiService.get<PageResultResponse>(DatabaseEntities.CLIENTS),
            ApiService.get<PageResultResponse>(
              `${DatabaseEntities.BUNDLES}?excludeUltra=true`
            ),
            ApiService.get<PageResultResponse>(DatabaseEntities.PRODUCTS),
            ApiService.get<PaymentMethod[]>("frontend/paymentMethods"),
            //ApiService.get<any>(DatabaseEntities.ULTRA_BUNDLES),
          ]);
        setClients(clientsData.items);
        setBundles(bundlesData.items);
        setProducts(productsData.items);
        setPaymentMethods(paymentMethodsData);
        //console.log(ultrabundleData);
      } catch (error) {
        AlertService.error(ToastMessages.FETCH_FAILED);
      } finally {
        setLoading(false);
      }
    };
    if (open && Misc.isArrayEmpty(clients)) fetchData();
  }, [open, clients]);

  const handleTabChange = (e: any, newValue: number) => setValue(newValue);

  const handleClient = (e: any) => {
    if (!e || !e.value || typeof e === "string") {
      setClient(null);
      return;
    }

    // Otherwise, e is an object with value and label properties
    let value = e.value;
    var clt = clients.find((x) => x.id == value);
    setClient(clt);
  };

  // Handle the add of a new task of bundle/product
  const handleAddTask = () => {
    const newTask: Task = {
      id: estimateItems.length + 1,
      task: "",
      description: "",
      quantity: 0,
      rate: 0,
      amount: 0,
      BundleItems: [],
      IsBundle: true, // Default to true for bundles
    };
    setEstimateItems([...estimateItems, newTask]);
  };

  // Handle the add of a new item/product
  const handleAddItem = (e: any, index: number) => {
    const updatedItems = [...estimateItems];

    const product: Product = {
      name: "",
      price: 0,
      isProduct: false,
      categoryId: 0,
    };

    const item: BundleItem = {
      bundleId: 0,
      productId: 0,
      Product: product,
      quantity: 0,
    };

    updatedItems[index].BundleItems.push(item);
    setEstimateItems(updatedItems);
  };

  // Handle the sum of items inside the task
  const handleTask = (e: any, index: number) => {
    let pos = parseInt(e.value);
    const updatedItems = [...estimateItems];
    if (e.type === "bundle") {
      var bundle = e.Bundle;

      if (!bundle) return;

      // update task info based on the bundle info
      updatedItems[index].id = pos;
      updatedItems[index].task = bundle.name;
      updatedItems[index].description = bundle.description ?? "";
      updatedItems[index].IsBundle = true; // Set IsBundle to true for bundles
      updatedItems[index].BundleItems = bundle.BundleItems ?? [];

      // vars to calculate the totals
      let totalRate: number = 0;
      let totalAmount: number = 0;

      // map the child items to calculate the total amount, quantity and rate of the bundle
      bundle.BundleItems?.map((item: BundleItem) => {
        totalRate += item.Product?.price ? parseInt(item.Product.price) : 0;
        totalAmount += item.Product?.price
          ? item.Product.price * item.quantity
          : 0;
      });
      updatedItems[index].rate = totalRate;
      updatedItems[index].amount = totalAmount;
      updatedItems[index].quantity =
        (bundle.BundleItems ?? []).length > 0 ? 1 : 0;
    } else if (e.type === "product") {
      var product = e.Product;

      if (!product) return;

      // update task info based on the product info
      updatedItems[index].id = pos;
      updatedItems[index].task = product.name;
      updatedItems[index].description = product.description ?? "";
      updatedItems[index].BundleItems = [];
      updatedItems[index].IsBundle = false; // Set IsBundle to false for products
      updatedItems[index].quantity = 1;
      updatedItems[index].rate = parseInt(product.price); // Set rate to product price
      updatedItems[index].amount = parseInt(product.price); // Quantity is 1 so no need to calculate
    }
    setEstimateItems(updatedItems);
  };

  // Handle the change of the item/product
  const handleItem = (e: any, index: number, pos: number) => {
    const updatedItems = [...estimateItems];
    let value = e.target.value;
    let prod = products.find((x) => x.name === value);
    if (prod) {
      updatedItems[index].BundleItems[pos].Product = prod;
      if (
        !updatedItems[index].BundleItems[pos].quantity ||
        updatedItems[index].BundleItems[pos].quantity < 1
      )
        updatedItems[index].BundleItems[pos].quantity = 1; // Ensure quantity is set to 1 if not already set
      setEstimateItems(updatedItems);
    }
  };

  // Handle the change of the description
  const handleDescription = (e: any, index: number, pos?: number) => {
    let description = e.target.value;

    const updatedItems = [...estimateItems];
    if (pos != undefined)
      updatedItems[index].BundleItems[pos].Product.description = description;
    else updatedItems[index].description = description;

    setEstimateItems(updatedItems);
  };

  // Handle the change of quantity
  const handleQuantity = (e: any, index: number, childIndex?: number) => {
    let value = parseInt(e.target.value);

    if (isNaN(value)) value = 0;

    if (value < 0) {
      AlertService.warning("Quantity cannot be negative.");
      return;
    }

    const updatedItems = [...estimateItems];

    // If its child task update the quantity of the child
    // Else, update all child quantities to recalculate the bundle
    if (childIndex != undefined) {
      updatedItems[index].BundleItems[childIndex].quantity = value;
    } else {
      updatedItems[index].quantity = value;
      updatedItems[index].amount = updatedItems[index].rate * value;

      // If it's a bundle, update all child item quantities
      if (updatedItems[index].IsBundle) {
        updatedItems[index].BundleItems.map((item) => {
          let currentQuantity = item.quantity;
          if (currentQuantity == 0) item.quantity = value;
          else item.quantity = value * currentQuantity;
          item.quantity = value;
        });
      }
    }

    setEstimateItems(updatedItems);
    // If it's a bundle, recalculate the total amount
    if (updatedItems[index].IsBundle) calculateBundleTotal(index);
  };

  // Handle the change of rate
  const handleRate = (e: any, index: number, pos?: number) => {
    let value = parseInt(e.target.value);

    // Ensure value is a number and remove leading zeros
    if (isNaN(value)) {
      value = 0;
    } else {
      value = Number(String(value).replace(/^0+/, "") || "0");
    }

    if (value < 0) {
      AlertService.warning("Rate cannot be negative.");
      return;
    }

    const updatedItems = [...estimateItems];

    if (pos != undefined) {
      updatedItems[index].BundleItems[pos].Product.price = value;
    }

    setEstimateItems(updatedItems);
    if (updatedItems[index].IsBundle) calculateBundleTotal(index);
  };

  // Handle the deletion of a task/bundle
  const handleDeleteTask = (index: number) => {
    setEstimateItems(estimateItems.filter((_, i) => i !== index));
    if (Misc.isArrayEmpty(estimateItems)) {
      // If the last task is deleted, reset the items to the initial state
      setEstimateItems([
        {
          id: 0,
          task: "",
          description: "",
          quantity: 0,
          rate: 0,
          amount: 0,
          BundleItems: [],
          IsBundle: true, // Default to true for bundles
        },
      ]);
    }
  };

  // Handle the deletion of an item/product inside a task/bundle
  const handleDeleteItem = (index: number, pos: number) => {
    const task = estimateItems[index];
    const updatedItems = [...estimateItems];
    const newItems = task.BundleItems?.filter((_, i) => i !== pos);

    updatedItems[index].BundleItems = newItems ?? [];

    setEstimateItems(updatedItems);
    if (updatedItems[index].IsBundle) calculateBundleTotal(index);
    if (newItems && Misc.isArrayEmpty(newItems)) handleDeleteTask(index);
  };

  // Handle the change of discount
  const handleDiscount = (e: any) => {
    let value = parseInt(e.target.value);
    let ttl = estimateItems.reduce((acc, item) => acc + item.amount, 0);

    if (discountType === "percentage") {
      if (value >= 0 && value <= 100) {
        // If the discount is a percentage, it should be between 0 and 100
        // If the discount is a percentage, it should not exceed the total amount
        if (value > ttl) {
          AlertService.warning(
            "Discount percentage cannot exceed total amount."
          );
          return;
        }
        setDiscount(value);
      }
    } else {
      if (value >= 0 && value <= ttl) setDiscount(value);
      else {
        AlertService.warning("Discount amount cannot exceed total amount.");
        return;
      }
    }
  };

  // Handle the change of discount type
  const handleDiscountType = () => {
    setDiscountType(discountType === "percentage" ? "amount" : "percentage");
    setDiscount(0);
  };

  const handleNotes = (e: any) => setNotes(e.target.value);

  // Handle start date
  const handleStartDate = (selectedDay: string) => {
    setSize(selectedDay);
    // based on selected size, set the start date
    switch (selectedDay) {
      case "Tomorrow":
        setStartsAt(new Date().setDate(new Date().getDate() + 1));
        break;
      case "In three days":
        setStartsAt(new Date().setDate(new Date().getDate() + 3));
        break;
      case "Next week":
        setStartsAt(new Date().setDate(new Date().getDate() + 7));
        break;
      default:
        setStartsAt(null);
        break;
    }
  };

  // Handle end date
  const handleDueDate = (selectedDay: string) => {
    setEndSize(selectedDay);
    // based on selected size, set the start date
    switch (selectedDay) {
      case "1 week":
        setDueDate(new Date().setDate(new Date().getDate() + 7));
        break;
      case "2 weeks":
        setDueDate(new Date().setDate(new Date().getDate() + 14));
        break;
      case "1 month":
        setDueDate(new Date().setDate(new Date().getDate() + 30));
        break;
      case "None":
        setDueDate(null);
        break;
      default:
        setDueDate(null);
        break;
    }
  };

  const handlePaymentMethod = (e: any) => setPaymentMethodId(e.target.value);
  const handleDeposit = (e: any) => setDeposit(!deposit);
  const handleUrgentPayment = (e: any) => setUrgentPayment(!urgentPayment);

  const handleStagedAmount = (e: any) => {
    let value = parseInt(e.target.value);
    let ttl = estimateItems.reduce((acc, item) => acc + item.amount, 0);

    if (ttl === 0) {
      AlertService.warning("Total amount cannot be zero.");
      return;
    }
    if (value >= 0 && value <= ttl) setStagedAmount(value);
  };

  const calculateBundleTotal = (index: number) => {
    const updatedItems = [...estimateItems];
    //vars to calculate the totals
    let totalRate: number = 0;
    //let totalQuantity: number = 0;
    let totalAmount: number = 0;

    //map the child items to calculate the total amount, quantity and rate of the bundle
    updatedItems[index].BundleItems.map((item: BundleItem) => {
      totalRate += item.Product?.price ? parseInt(item.Product.price) : 0;
      //totalQuantity += item.quantity;
      totalAmount += item.Product?.price
        ? item.Product.price * item.quantity
        : 0;
    });
    updatedItems[index].rate = totalRate;
    //updatedItems[index].quantity = totalQuantity;
    updatedItems[index].amount = totalAmount;

    setEstimateItems(updatedItems);
  };

  // Calculate the total amount of the estimate everytime the amount, rate, quantity or discount changes
  useEffect(() => {
    let totVal = estimateItems.reduce((acc, item) => acc + item.amount, 0);
    // Calculate the discount amount
    let discountedAmount = 0;

    if (discountType === "percentage")
      discountedAmount = (discount / 100) * totVal;
    else discountedAmount = discount;

    // Calculate the final amount after discount, with 2 decimal case
    let finalAmount = parseFloat((totVal - discountedAmount).toFixed(2));
    setTotal(finalAmount);
  }, [handleRate, handleQuantity, handleDiscount, handleDeleteItem]);

  const handleCreate = async (payload: Estimate) => {
    try {
      const res: Estimate = await ApiService.post<Estimate>(
        DatabaseEntities.ESTIMATES,
        payload
      );
      AlertService.success(ToastMessages.CREATED);
      setClient(null);
      setNotes(null);
      setApproved(false);
      setAcceptedBy(null);
      setAcceptedAt(null);
      setUrgentPayment(false);
      setEstimateItems([
        {
          id: 0,
          task: "",
          description: "",
          quantity: 0,
          rate: 0,
          amount: 0,
          BundleItems: [],
          IsBundle: true, // Default to true for bundles
        },
      ]);
      setTotal(null);
      setDiscount(0);
      setStagedAmount(0);
      setPaymentMethodId(null);
      setDeposit(false);
      setAttachments([]);
      resetList();

      return res;
    } catch {
      AlertService.error(ToastMessages.CREATE_FAILED);
      return null;
    }
  };

  const handleUpdate = async (payload: Estimate) => {
    try {
      const res: Estimate = await ApiService.put<Estimate>(
        `${DatabaseEntities.ESTIMATES}/${payload.code}`,
        payload
      );
      AlertService.success(ToastMessages.UPDATED);
      setLoading(true);

      resetList();

      return res;
    } catch {
      AlertService.error(ToastMessages.UPDATE_FAILED);
      return null;
    }
  };

  const handleDelete = async (payload: Estimate) => {
    await ApiService.delete<any>(
      `${DatabaseEntities.ESTIMATES}/${payload.code}`
    )
      .then(() => {
        setLoading(true);
        AlertService.success(ToastMessages.DELETED);
        resetList();
      })
      .catch(() => {
        AlertService.error(ToastMessages.DELETE_FAILED);
      });
  };

  // Check if the input is valid
  const invalidInput = (): boolean => {
    //Check if bundle has task and positive quantity

    let invalid: boolean =
      estimateItems.length > 0 &&
      (estimateItems.some((x) => x.task == "") ||
        estimateItems.some((x) => x.quantity == 0));

    invalid = !client || !userId || !startsAt || !dueDate;

    return invalid;
  };

  const handleFileChange = async (e: any) => {
    const selectedFiles = Array.from(e.target.files) as File[];

    if (selectedFiles.length > 10) {
      AlertService.warning(ToastMessages.MAX_IMAGES_UPLOAD);
      return;
    }

    for (const file of selectedFiles) {
      if (file.size > 5 * 1024 * 1024) {
        // Compress images
        const compressedFile = await ImageCompressor.compress(file);
        // Replace the original file with the compressed file
        const index = selectedFiles.indexOf(file);
        if (index !== -1 && compressedFile) {
          selectedFiles[index] = compressedFile;
          AlertService.info(
            "File size to large, compressed image: " + file.name
          );
        }
      }
    }

    setAttachments(selectedFiles);
  };

  const handleFileUpload = async (code: string) => {
    await FirebaseService.uploadFiles(attachments, `Estimate/${code}`)
      .then(async (urls: string[]) => {
        if (urls.length > 0) {
          const data = {
            estimateCode: code,
            fileNames: attachments.map((file) => file.name),
            filePaths: urls,
          };

          await ApiService.post<any>(
            `${DatabaseEntities.ESTIMATES}/${DatabaseEntities.ATTACHMENTS}`,
            data
          )
            .then(() => {
              AlertService.success(ToastMessages.IMAGES_UPLOADED);
            })
            .catch(() => {
              AlertService.error(ToastMessages.IMAGES_ERROR_SERVER);
            });
        }
      })
      .catch((error) => {
        AlertService.error(ToastMessages.IMAGES_ERROR_FIREBASE);
        console.error(`${ToastMessages.IMAGES_ERROR_FIREBASE}:`, error);
      });
    setAttachments([]);
  };

  const handleStagedPayment = async (estimate: Estimate | null | void) => {
    // If the estimate is created/updated successfully and deposit is required, create a staged payment
    if (deposit && estimate?.code && stagedAmount > 0 && paymentMethodId) {
      const stagedPayment: StagedPayment = {
        estimateCode: code,
        paymentMethodId: paymentMethodId,
        amount: stagedAmount,
      };

      try {
        await ApiService.post<StagedPayment>(
          DatabaseEntities.STAGED_PAYMENTS,
          stagedPayment
        );
      } catch {
        AlertService.error(
          `${ToastMessages.CREATE_FAILED}: Failed to create staged payment`
        );
        console.log(ToastMessages.CREATE_FAILED);
      }
    }
  };

  // Form submission
  const submit = async () => {
    if (invalidInput()) return;

    setLoading(true);

    const payload: Estimate = {
      code: edit ? code : null,
      clientId: client?.id,
      total: total,
      dueDate: dueDate,
      statusId: status.id ?? 2,
      userId: userId,
      notes: notes,
      approved: approved,
      acceptedBy: acceptedBy,
      acceptedAt: acceptedAt,
      startsAt: startsAt,
      urgentPayment: urgentPayment,
      discount: discount,
      items: estimateItems,
    };

    var response = null;
    if (edit) {
      response = await handleUpdate(payload);
    } else {
      response = await handleCreate(payload);
    }

    await handleStagedPayment(response);

    // If the estimate is created successfully and have submitted attachments, handle file upload
    if (response && attachments.length > 0) await handleFileUpload(code);

    setLoading(false);
    //reset all constants when the estimate is created

    handleClose();
  };

  const handleReorderItem = (index: number, pos: number) => {
    const updatedItems = [...estimateItems];
    if (pos > 0 && pos < updatedItems[index].BundleItems.length) {
      let item = updatedItems[index].BundleItems[pos];
      updatedItems[index].BundleItems.splice(pos, 1);
      updatedItems[index].BundleItems.splice(pos - 1, 0, item);
      setEstimateItems(updatedItems);
    }
  };

  return (
    <div>
      {edit ? (
        <Button onClick={handleOpen}>
          <img src={EditIcon} alt="edit icon" />
        </Button>
      ) : (
        <Btn
          className={classes.headerButton}
          variant="contained"
          onClick={handleOpen}
        >
          + Add Estimate
        </Btn>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <Box sx={style}>
            {/** Header */}
            <Card style={{ padding: "25px" }}>
              <div className={classes.headerDiv}>
                <Typography
                  variant="subtitle1"
                  style={{
                    color: DarkGrey,
                    textAlign: "center",
                    width: "auto",
                    fontSize: "1.1rem",
                  }}
                >
                  Estimate
                </Typography>
                <div className={classes.headerSubDiv}>
                  {edit && (
                    <Typography className={classes.title}>
                      <DeleteModal
                        item={estimate}
                        handleDelete={handleDelete}
                      />
                    </Typography>
                  )}
                  <Button onClick={handleClose} sx={{ color: "black" }}>
                    <CloseIcon />
                  </Button>
                </div>
              </div>
              <hr />
              <div>
                <Box
                  sx={{ width: "20%", borderBottom: 1, borderColor: "divider" }}
                >
                  <Tabs
                    value={value}
                    onChange={handleTabChange}
                    centered
                    variant="standard"
                    textColor="inherit"
                    indicatorColor="primary"
                    TabIndicatorProps={{
                      sx: { height: 2, bgcolor: PrimaryColor }, // Customize the underline
                    }}
                  >
                    <Tab
                      label={edit ? "Save" : "Create"}
                      sx={{
                        opacity: value === 0 ? 1 : 0.5,
                        textTransform: "capitalize",
                      }}
                    />
                  </Tabs>
                </Box>
              </div>
            </Card>
            {/** Form */}
            <div className={classes.form}>
              <Card style={{ width: "80%", padding: "5px" }}>
                <CardContent>
                  {/** Header */}
                  <div className={classes.headerDiv}>
                    <div className="d-flex col align-items-center">
                      <Typography
                        style={{
                          color: PrimaryColor,
                          fontSize: "2rem",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          marginRight: "10px",
                        }}
                      >
                        Estimate
                      </Typography>
                      <Typography style={{ color: PrimaryColor }}>
                        {edit && `#${code}`}
                      </Typography>
                    </div>
                    <img src={MainLogo} alt="logo" width={120} height={50} />
                  </div>
                  <div className="d-flex col w-100 mt-2">
                    <div className="d-flex row">
                      <Typography>Setup Remodeling Inc.</Typography>
                      <Typography>72 Cash St.</Typography>
                      <Typography>Fall River Ma 02723</Typography>
                    </div>
                    <div className="d-flex row mx-1">
                      <Typography>sales@setupremodeling.com</Typography>
                      <Typography>+1 (800)-530-4099</Typography>
                      <Typography>wwww.setupremodeling.com</Typography>
                    </div>
                  </div>
                  <div className={`${classes.inputGroup}`}>
                    <Select
                      styles={styles}
                      value={
                        client?.id
                          ? {
                              value: client.id,
                              label: `${client.firstName} ${client.lastName}`,
                            }
                          : ""
                      }
                      isClearable={true}
                      onChange={handleClient}
                      options={clients.map((clt: Client) => ({
                        value: clt.id,
                        label: `${clt.firstName} ${clt.lastName}`,
                      }))}
                      placeholder="Select Client"
                    />
                    {!edit && (
                      <ClientModal
                        externalService={true}
                        resetList={() => setClients([])}
                        setClient={(clt: Client) => setClient(clt)}
                      />
                    )}
                  </div>
                  <hr />
                  {/** Body */}
                  <div className="table-container">
                    <table className="styled-table">
                      <thead style={{ color: "rgba(117, 117, 117, 1)" }}>
                        <td>Task</td>
                        <td>Description</td>
                        <td>Quantity</td>
                        <td>Rate</td>
                        <td>Total</td>
                        <td>Action</td>
                      </thead>
                      <tbody className="overflow-auto">
                        {estimateItems.map((row: Task, index: number) => (
                          <React.Fragment key={row.id}>
                            {/* Parent Row */}
                            <tr key={row.id}>
                              <td>
                                <Select
                                  styles={styles}
                                  value={
                                    row.id
                                      ? {
                                          value: row.id,
                                          label: `${row.task}`,
                                        }
                                      : ""
                                  }
                                  isClearable={false}
                                  onChange={(e) => handleTask(e, index)}
                                  options={[
                                    ...bundles.map((bundle: Bundle) => ({
                                      value: bundle.id,
                                      label: bundle.name,
                                      type: "bundle",
                                      Bundle: bundle,
                                    })),
                                    ...products.map((product: Product) => ({
                                      value: product.id,
                                      label: product.name,
                                      type: "product",
                                      Product: product,
                                    })),
                                  ]}
                                  placeholder="Select task"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  placeholder="Add a description.."
                                  value={estimateItems[index].description}
                                  onChange={(e) => handleDescription(e, index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  placeholder="01"
                                  min={1}
                                  style={{ width: "4rem" }}
                                  value={estimateItems[index].quantity}
                                  disabled={
                                    row.IsBundle && row.BundleItems.length == 0
                                  }
                                  onChange={(e) => handleQuantity(e, index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  placeholder="01"
                                  min={1}
                                  style={{ width: "4rem" }}
                                  value={estimateItems[index].rate}
                                  disabled={row.BundleItems.length > 0}
                                  onChange={(e) => handleRate(e, index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  placeholder="01"
                                  style={{ width: "5rem" }}
                                  value={estimateItems[index].amount}
                                  disabled
                                />
                              </td>
                              <td>
                                <Button
                                  className="delete-btn"
                                  onClick={() => handleDeleteTask(index)}
                                >
                                  🗑️
                                </Button>
                              </td>
                            </tr>
                            {/* Child Rows */}
                            <>
                              {row.IsBundle &&
                                row.BundleItems.map(
                                  (child: BundleItem, pos: number) => (
                                    <tr key={child.id}>
                                      <td
                                        style={{
                                          paddingLeft: "30px",
                                        }}
                                      >
                                        {/* <div className="d-flex row w-25">
                                      <Button
                                        className="reorder-btn"
                                        onClick={() =>
                                          handleReorderItem(index, pos)
                                        }
                                      >
                                        ↑
                                      </Button>
                                      <Button
                                        className="reorder-btn"
                                        onClick={() =>
                                          handleReorderItem(index, pos + 1)
                                        }
                                      >
                                        ↓
                                      </Button>
                                    </div> */}
                                        <select
                                          className={classes.input}
                                          style={{
                                            background: "#F1F2F3",
                                            color: "grey",
                                          }}
                                          value={child.Product?.name}
                                          onChange={(e) =>
                                            handleItem(e, index, pos)
                                          }
                                        >
                                          <option value="" disabled>
                                            Select task
                                          </option>
                                          {products.map((prod: Product) => {
                                            return (
                                              <option
                                                key={prod.id}
                                                value={prod.name}
                                              >
                                                {prod.name}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          style={{
                                            background: "#F1F2F3",
                                            color: "grey",
                                          }}
                                          type="text"
                                          placeholder="Add a description.."
                                          value={child.Product.description}
                                          onChange={(e) =>
                                            handleDescription(e, index, pos)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          style={{
                                            background: "#F1F2F3",
                                            color: "grey",
                                          }}
                                          type="number"
                                          placeholder="01"
                                          min={1}
                                          value={child.quantity}
                                          onChange={(e) =>
                                            handleQuantity(e, index, pos)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          style={{
                                            background: "#F1F2F3",
                                            color: "grey",
                                          }}
                                          type="number"
                                          placeholder="01"
                                          min={1}
                                          value={child.Product.price}
                                          onChange={(e) =>
                                            handleRate(e, index, pos)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          style={{
                                            background: "#F1F2F3",
                                            color: "grey",
                                          }}
                                          type="number"
                                          placeholder="01"
                                          value={
                                            child.Product.price * child.quantity
                                          }
                                          disabled
                                        />
                                      </td>
                                      <td>
                                        <Button
                                          className="delete-btn"
                                          onClick={() =>
                                            handleDeleteItem(index, pos)
                                          }
                                        >
                                          🗑️
                                        </Button>
                                      </td>
                                    </tr>
                                  )
                                )}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  {row.IsBundle && row.id != 0 && (
                                    <Btn
                                      className={classes.externalButton}
                                      style={{ width: "100%" }}
                                      onClick={(e) => handleAddItem(e, index)}
                                    >
                                      + Add Item
                                    </Btn>
                                  )}
                                </td>
                              </tr>
                            </>
                          </React.Fragment>
                        ))}
                        <tr className="add-item-row">
                          <td
                            colSpan={6}
                            className="add-item"
                            onClick={handleAddTask}
                          >
                            <span>+ Add Task</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="d-flex col w-100 mt-2 align-items-center justify-content-end"
                    style={{ width: "200px" }}
                  >
                    <Typography>Discount:</Typography>
                    <input
                      className={classes.input}
                      type="number"
                      id="discount-1"
                      value={discount}
                      min={0}
                      max={100}
                      onChange={handleDiscount}
                    />
                    <div className="radio-container">
                      <div className="tabs">
                        <input
                          type="radio"
                          id="radio-1"
                          name="tabs"
                          checked={discountType === "percentage"}
                          onChange={handleDiscountType}
                        />
                        <label className="tab" htmlFor="radio-1">
                          %
                        </label>
                        <input
                          type="radio"
                          id="radio-2"
                          name="tabs"
                          checked={discountType === "amount"}
                          onChange={handleDiscountType}
                        />
                        <label className="tab" htmlFor="radio-2">
                          $
                        </label>
                      </div>
                    </div>
                    {/* <Btn onClick={handleDiscountType}>
                      <span>%</span>
                    </Btn>
                    <Btn onClick={handleDiscountType}>
                      <span>$</span>
                    </Btn> */}
                  </div>
                  {/* <div className="d-flex col w-100 mt-2 align-items-center justify-content-end">
                    <Typography>Total Amount:</Typography>
                    <Typography
                      style={{
                        color: PrimaryColor,
                        fontSize: "20px",
                        marginLeft: "10px",
                      }}
                    >
                      ${total},00
                    </Typography>
                  </div> */}
                  <div className="d-flex row mt-5 align-items-center">
                    <Typography>Notes to costumer</Typography>
                    <textarea
                      className={classes.input}
                      value={notes}
                      onChange={handleNotes}
                      placeholder="Thank you.."
                    />
                  </div>
                  <div className="d-flex row align-items-center">
                    <Typography>Attachments</Typography>
                    <input
                      className={classes.input}
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      accept="image/*,application/pdf"
                    />
                  </div>
                  {attachments.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {attachments.map((file, idx) => (
                        <div
                          key={idx}
                          style={{
                            width: 60,
                            height: 60,
                            border: "1px solid #eee",
                            borderRadius: 4,
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#fafafa",
                          }}
                        >
                          {file.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(file)}
                              alt={file.name}
                              title={file.name}
                              style={{ maxWidth: "100%", maxHeight: "100%" }}
                              onLoad={(e) =>
                                URL.revokeObjectURL(
                                  (e.target as HTMLImageElement).src
                                )
                              }
                            />
                          ) : (
                            <span
                              style={{
                                fontSize: 12,
                                color: "#888",
                                textAlign: "center",
                              }}
                            >
                              {file.name}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
              {/** Details */}
              <div className={classes.detailsDiv}>
                <Card>
                  <CardContent>
                    <Typography className={classes.detailsTitle}>
                      Details
                    </Typography>
                    <div className="d-flex col mt-4 justify-content-between align-items-center">
                      <Typography style={{ color: "grey", fontSize: "15px" }}>
                        Estimate total:
                      </Typography>
                      <Typography>{Misc.toUSD(total)}</Typography>
                    </div>
                    {edit && (
                      <div className="d-flex col justify-content-between align-items-center">
                        <Typography style={{ color: "grey", fontSize: "15px" }}>
                          Due date:
                        </Typography>
                        <Typography>
                          {DateConverter.toCompleteDate(dueDate)}
                        </Typography>
                      </div>
                    )}
                    <div className="d-flex col justify-content-between align-items-center">
                      <Typography style={{ color: "grey", fontSize: "15px" }}>
                        Status:
                      </Typography>
                      <div style={{ width: "50%" }}>
                        <Typography
                          style={DB_Status.mapStatusColor(status.name)}
                        >
                          <div
                            style={DB_Status.mapStatusRoundedColor(status.name)}
                          ></div>
                          {status.name}
                        </Typography>
                      </div>
                    </div>
                    {edit && (
                      <div className="d-flex col justify-content-between align-items-center">
                        <Typography style={{ color: "grey", fontSize: "15px" }}>
                          Created At:
                        </Typography>
                        <Typography>
                          {DateConverter.toFullDate(createdAt)}
                        </Typography>
                      </div>
                    )}
                    <hr />
                    <div className="d-flex col justify-content-between align-items-center">
                      <Typography style={{ color: "grey", fontSize: "15px" }}>
                        Urgent payment
                      </Typography>
                      {urgentPayment ? (
                        <Button
                          sx={{ color: PrimaryColor }}
                          onClick={handleUrgentPayment}
                        >
                          <ToggleOnIcon />
                        </Button>
                      ) : (
                        <Button
                          sx={{ color: DarkGrey }}
                          onClick={handleUrgentPayment}
                        >
                          <ToggleOffIcon />
                        </Button>
                      )}
                    </div>
                    <div className="d-flex mt-2 row w-100 flex-wrap">
                      <Typography style={{ color: "grey", fontSize: "15px" }}>
                        Starts:
                      </Typography>
                      {[
                        "Tomorrow",
                        "In three days",
                        "Next week",
                        "Select date",
                      ].map((sizeOption) => (
                        <label key={sizeOption} style={{ color: DarkGrey }}>
                          <input
                            type="radio"
                            name="size"
                            value={sizeOption}
                            checked={size === sizeOption}
                            onChange={() => handleStartDate(sizeOption)}
                            className="hidden"
                          />
                          {sizeOption}
                        </label>
                      ))}
                      {size === "Select date" && (
                        <CalendarWrapper>
                          <Calendar
                            className={classes.calendar}
                            calendarType={"US"}
                            value={startsAt}
                            tileDisabled={({ date }) => date.getDay() === 6} //disabled on saturdays
                            onChange={(date: any) => setStartsAt(date)}
                          />
                        </CalendarWrapper>
                      )}
                    </div>
                    <div className="d-flex mt-2 row w-100 flex-wrap">
                      <Typography style={{ color: "grey", fontSize: "15px" }}>
                        Due date:
                      </Typography>
                      {["1 week", "2 weeks", "1 month", "None"].map(
                        (option) => (
                          <label key={option} style={{ color: DarkGrey }}>
                            <input
                              type="radio"
                              name="endsize"
                              value={option}
                              checked={endSize === option}
                              onChange={() => handleDueDate(option)}
                              className="hidden"
                            />
                            {option}
                          </label>
                        )
                      )}
                    </div>
                    <hr />
                    <div>
                      <div className="d-flex col justify-content-between align-items-center">
                        <Typography>Deposit</Typography>
                        {deposit ? (
                          <Button
                            sx={{ color: PrimaryColor }}
                            onClick={handleDeposit}
                          >
                            <ToggleOnIcon />
                          </Button>
                        ) : (
                          <Button
                            sx={{ color: DarkGrey }}
                            onClick={handleDeposit}
                          >
                            <ToggleOffIcon />
                          </Button>
                        )}
                      </div>
                      {deposit && (
                        <>
                          <select
                            className={classes.input}
                            value={paymentMethodId}
                            onChange={handlePaymentMethod}
                          >
                            <option value="">Select payment method</option>
                            {paymentMethods.map((method) => {
                              return (
                                <option key={method.id} value={method.id}>
                                  {method.name}
                                </option>
                              );
                            })}
                          </select>
                          <input
                            type="number"
                            className={classes.input}
                            placeholder="Amount"
                            value={stagedAmount}
                            onChange={handleStagedAmount}
                          />
                          <span>$</span>
                          {/** TODO: add more deposit types */}
                          {/* <Button sx={{ color: PrimaryColor }}>
                            + Add new
                          </Button> */}
                        </>
                      )}
                    </div>
                  </CardContent>
                </Card>
                <div className="d-flex justify-content-end">
                  <Btn
                    className={classes.button}
                    disabled={invalidInput()}
                    onClick={submit}
                  >
                    {edit ? "Save" : "Create"}
                  </Btn>
                </div>
              </div>
            </div>
          </Box>
        )}
      </Modal>
    </div>
  );
};

export default EstimateModal;
